// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","aliases":"Aliases-module--aliases--d308dd","items":"Aliases-module--items--7f1276"};